import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { translate } from '../Services/translation';
import GermanyChooseReseller from "../Bahag/GermanyChoosReseller";

import {
    acceptTermsOfCondition,
    setBusinessCustomer,
    setCampaignCode,
    setDelivery,
    setPayment,
    setOrderNote,
    submit,
    verify,
    setCustomerDetails,
    setAlternativeAddress,
    setSignUp,
    setSelectedCompanyAddress,
    submitError,
    reloadPayment,
    submitCampaignCode,
    removeCampaignCode,
    submitRequest,
    submitDone,
} from '../Actions/Checkout.action';

import { update as updateOrderRowQuantity } from '../Actions/Cart.action';
import BahagContainer from "../Bahag/GermanyContainer";
import GermanyCart from '../Bahag/GermanyCart';

class CheckoutBahagContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobileOrTablet: window.innerWidth <= 1024
        }
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
        this.setState({ isMobile: window.innerWidth <= 1024 });
    }

    renderCartSection() {
        const { checkout } = this.props,
            { errors = {} } = checkout;
        return (
            <Fragment>
                <GermanyCart {...{
                    ...this.props.cart,
                    updateOrderRowQuantity: this.props.updateOrderRowQuantity,
                    removeOrderRow: this.props.removeOrderRow,
                    onCampaignCodeChange: this.props.setCampaignCode,
                    onSubmitCampaignCode: this.props.submitCampaignCode,
                    onRemoveCampaignCode: this.props.removeCampaignCode,
                    errors: errors
                }} />
            </Fragment>
        );
    }

    renderError(errors) {
        return (
            <div className="  ">
                {errors && errors['general'] && <p className="checkout__validator--error">{errors['general'][0]}</p>}
            </div>
        )
    }

    renderCartState() {
        return (
            <div className='checkout__productsList' id="bahag-cart">
                {this.renderCartSection()}
            </div>
        )
    }

    render() {
        const { cart } = this.props;
        const { isMobileOrTablet } = this.state;

        if (!cart || !cart.orderRows || cart.orderRows.length < 1) {
            return (
                <div className="grid-full-width">
                    <h2 className="checkout__empty-title">{translate(`checkout.cart.empty`)}</h2>
                </div>
            );
        }

        const { checkout } = this.props,
            { payload, errors = {} } = checkout,
            { orderNote, paymentWidget, paymentMethods, authenticated, isBusinessCustomer, checkoutMode } = payload;

        return (
            <div className='grid-full-width'>
                <Fragment>
                    <div className="germany-checkout--title">
                        <h2>{translate('checkout.title')}</h2>
                        {window.__litium.resellerFormUrl && window.__litium.resellerFormUrl !== "undefined" ? (
                            <div className="germany-reseller__apply-reseller">
                                <a href={window.__litium.resellerFormUrl}>
                                    {translate("reseller.apply.button.text")}
                                </a>
                            </div>
                        ) : null}
                    </div>
                    {isMobileOrTablet ? (
                        <Fragment>
                            <GermanyChooseReseller />
                            {this.renderCartState()}
                            <BahagContainer />
                            {this.renderError(errors)}
                        </Fragment>
                    ) : (
                        <Fragment>
                            {this.renderCartState()}
                            <GermanyChooseReseller />
                            <BahagContainer />
                            {this.renderError(errors)}
                        </Fragment>
                    )}
                </Fragment>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { cart, checkout } = state;
    return {
        cart,
        checkout,
        productStock: state.bahag.productStock,
        orderRowsWithStock: state.bahag.orderRowsWithStock
    }
}

const mapDispatchToProps = dispatch => {
    return {
        submit: () => dispatch(submit()),
        setBusinessCustomer: (value) => dispatch(setBusinessCustomer(value)),
        setCampaignCode: (code) => dispatch(setCampaignCode(code)),
        setDelivery: (systemId) => dispatch(setDelivery(systemId)),
        setPayment: (systemId) => dispatch(setPayment(systemId)),
        setOrderNote: (note) => dispatch(setOrderNote(note)),
        acceptTermsOfCondition: (accept) => dispatch(acceptTermsOfCondition(accept)),
        verify: (url, orderId, payload) => dispatch(verify(url, orderId, payload)),
        onSignUpChange: (signUp) => dispatch(setSignUp(signUp)),
        submitCampaignCode: () => dispatch(submitCampaignCode()),
        removeCampaignCode: () => dispatch(removeCampaignCode()),
        submitRequest: () => dispatch(submitRequest()),
        submitError: (error) => {
            dispatch(submitError(error));
            dispatch(submitDone(null));
        },
        setSelectedCompanyAddress: (companyId) => dispatch(setSelectedCompanyAddress(companyId)),
        onCustomerDetailsChange: (stateKey, propName, value) => {
            switch (stateKey) {
                case 'customerDetails':
                    dispatch(setCustomerDetails(propName, value));
                    break;
                case 'alternativeAddress':
                    dispatch(setAlternativeAddress(propName, value));
                    break;
            }
        },

        updateOrderRowQuantity: (rowId, quantity) => dispatch(updateOrderRowQuantity(rowId, quantity)).then(() => dispatch(reloadPayment())),
        removeOrderRow: (rowId) => dispatch(updateOrderRowQuantity(rowId, 0)).then(() => dispatch(reloadPayment())),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutBahagContainer);